import React from 'react';
import { Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import {
  formatUpdatedAt,
  resolveSessionDisplayTitle,
} from './sessionIdentity.js';
import SessionRunStatusIndicator from './SessionRunStatusIndicator.jsx';

const { Text } = Typography;

function resolveSessionTimestamp(session, showTimestamp) {
  if (!showTimestamp) {
    return '';
  }
  return formatUpdatedAt([
    session?.updatedAt,
    session?.updated_at,
    session?.createdAt,
    session?.created_at,
  ].find(Boolean));
}

function SessionFacts({ factLabels }) {
  const labels = Array.isArray(factLabels) ? factLabels.filter(Boolean) : [];
  return labels.map((label) => (
    <span className="flare-session-item-fact" key={label} title={label}>
      <FileTextOutlined aria-hidden="true" />
      <span>{label}</span>
    </span>
  ));
}

export default function SessionTitle({
  factLabels,
  session,
  sessionLoading,
  sessionRunning,
  showFullTitle,
  showTimestamp,
}) {
  const timestamp = resolveSessionTimestamp(session, showTimestamp);
  const hasFacts = Array.isArray(factLabels) && factLabels.some(Boolean);
  const titleNode = (
    <span className="flare-session-title-row">
      <Text
        className={['flare-session-item-title', showFullTitle ? 'is-complete' : ''].filter(Boolean).join(' ')}
        ellipsis={!showFullTitle}
        strong
      >
        {resolveSessionDisplayTitle(session)}
      </Text>
      <SessionRunStatusIndicator
        fallbackRunning={sessionRunning}
        loading={sessionLoading}
        loadingLabel="加载中"
        runProjection={session.run_progress}
        title={sessionLoading ? '正在加载会话' : '当前任务运行中'}
      />
    </span>
  );
  if (!timestamp && !hasFacts) {
    return titleNode;
  }
  return (
    <span className="flare-session-title-copy">
      {titleNode}
      <span className="flare-session-item-metadata">
        {timestamp ? (
          <Text className="flare-session-item-date" type="secondary">{timestamp}</Text>
        ) : null}
        <SessionFacts factLabels={factLabels} />
      </span>
    </span>
  );
}
